@if (isUser()) {
    <button
        id="ciComplaintsBtn"
        type="button"
        class="btn btn-warning btn-sml d-print-none shadow-sm"
        (click)="raiseComplaint()"
        ngbTooltip='Report "serious adverse events" or "product problems" that may be linked to repackaging.'
        placement="top"
    >
        <fa-icon [icon]="faFrown" class="mr-1"></fa-icon>
        Complaints?
    </button>
}
